module.exports = __webpack_public_path__ + "static/media/tomassalfischberger.52e4d0b0.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/tomassalfischberger.webp
// module id = 855
// module chunks = 0